import { CustomCellRendererProps } from '@mint-lib/ag-grid/react';
import { useState } from 'react';

import { Duplicate } from '@mint-lib/icons';
import { useIsAllowedPermission } from '@mint-lib/profile-helpers';
import {
  Button,
  Popover,
  PopoverContent,
  PopoverPortal,
  PopoverTrigger,
} from '@mint-lib/tw-components';
import type { MediaPlan } from '@mint-sdk/api-media-plan';

import { useChosenVersionId } from '../../../../../../hooks/useChosenVersionId.js';
import DuplicateMediaRow from '../DuplicateMediaRow/DuplicateMediaRow.jsx';

const DuplicateRowButton = ({
  data,
}: CustomCellRendererProps<MediaPlan.MediaData>) => {
  const [isOpen, setIsOpen] = useState(false);
  const chosenVersionId = useChosenVersionId();

  const isReadOnly = !useIsAllowedPermission('campaignPlanningFeature:modify');

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="text"
          size="small"
          icon
          aria-label="Duplicate row"
          disabled={isReadOnly || !!chosenVersionId}
        >
          <Duplicate className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverPortal>
        <PopoverContent className="z-popover w-74 px-0 py-1" align="end">
          {data && (
            <DuplicateMediaRow
              mediaData={data}
              closeMenu={() => setIsOpen(false)}
            />
          )}
        </PopoverContent>
      </PopoverPortal>
    </Popover>
  );
};

export default DuplicateRowButton;
